import React, { useState } from "react"
import { Button, Flex, Card } from "antd"
import { FileTextOutlined, DownloadOutlined } from "@ant-design/icons"
import { spacings, colors } from "themes/variables"
import LicensesModal from "./modal/LicensesModal"
import WithEmptyStateWrapper from "ui/WithEmptyStateWrapper"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import LicenseCertificate from "ui/Icon/DSIcon/LicenseCertificate"

const LicensesCertifications = ({ licenses = [] }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleEdit = () => {
    setIsModalOpen(true)
  }

  const handleSave = (files) => {
    // TODO: Save licenses data
    console.log("Save licenses", files)
    setIsModalOpen(false)
  }

  const handleDownload = (license) => {
    // TODO: Download license file
    console.log("Download license", license)
  }

  const { t } = useTranslation()

  return (
    <Flex vertical gap={spacings.M} className={styles.container}>
      {/* Header */}
      <Flex align="center" justify="space-between" className={styles.header}>
        <h2 className={styles.title}>{t("crewMember.licenses.title")}</h2>
        <Button type="link" onClick={handleEdit} className={styles.editButton}>
          {t("global.edit")}
        </Button>
      </Flex>

      {/* List with Empty State */}
      <WithEmptyStateWrapper
        name="licenses"
        hasItems={licenses.length > 0}
        fallback={
          <Card className="py-5xl">
            <Flex vertical justify="center" align="center" gap={12}>
              <LicenseCertificate />
              <Text color={colors.textPrimary} weight="semibold">
                {t("crewMember.licenses.emptyState.title")}
              </Text>
              <Text color={colors.textSecondaryDark}>{t("crewMember.licenses.emptyState.subtitle")}</Text>
            </Flex>
          </Card>
        }
      >
        <Flex vertical gap={spacings.XS} className={styles.list}>
          {licenses.map((license) => (
            <Flex key={license?.uid} align="center" justify="space-between" gap={spacings.L} className={styles.item}>
              <Flex align="center" gap={spacings.XXS} className={styles.fileInfo}>
                <FileTextOutlined className={styles.fileIcon} />
                <span className={styles.fileName}>{license?.name}</span>
              </Flex>
              <Button type="text" icon={<DownloadOutlined />} onClick={() => handleDownload(license)} className={styles.downloadButton} />
            </Flex>
          ))}
        </Flex>
      </WithEmptyStateWrapper>

      {/* Licenses Modal */}
      <LicensesModal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSave={handleSave}
        mode="edit"
        initialFiles={licenses.map((license, index) => ({
          uid: license?.uid || `${index}`,
          name: license?.name,
          status: "done"
        }))}
      />
    </Flex>
  )
}

LicensesCertifications.propTypes = {
  licenses: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string,
      name: PropTypes.string.isRequired,
      status: PropTypes.string,
      percent: PropTypes.number
    })
  ).isRequired
}

export default LicensesCertifications
